﻿package com.mgacreative.hotelru.feature.maintenance.di

import com.mgacreative.hotelru.feature.maintenance.ui.MaintenanceViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getMaintenanceFeatureModule() = module {
    viewModel { MaintenanceViewModel(get(), get(), get()) }
}

